import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";

const NumberTextfield = ({
  value,
  setValue,
  fullWidth,
  disabled,
  style,
  sx,
  InputProps = {
    style: { padding: "0px 6px" },
  },
  size,
  variant = "outlined",
  placeholder,
  decimalPlaces,
  error,
  currency,
}: {
  value?: number;
  setValue?: (value: number) => void;
  fullWidth?: boolean;
  disabled?: boolean;
  style?: any;
  sx?: any;
  InputProps?: any;
  size?: "small" | "medium";
  variant?: "standard" | "outlined" | "filled";
  placeholder?: string;
  decimalPlaces?: number;
  error?: boolean;
  currency?: boolean;
}) => {
  const [InputProperties, setInputProperties] = useState<any>({});

  useEffect(() => {
    if (InputProps && !currency) {
      return setInputProperties(InputProps);
    }
    if (!InputProps && currency) {
      return setInputProperties({
        style: { paddingLeft: 6 },
        startAdornment: (
          <InputAdornment style={{ padding: 0, margin: 0 }} position="start">
            <div style={{ fontSize: 12 }}>$</div>
          </InputAdornment>
        ),
      });
    }

    if (InputProps && currency) {
      return setInputProperties({
        ...(InputProps || {}),
        style: { ...(InputProps.style || {}), paddingLeft: 6 },
        startAdornment: (
          <InputAdornment style={{ padding: 0, margin: 0 }} position="start">
            <div style={{ fontSize: 12 }}>$</div>
          </InputAdornment>
        ),
      });
    }

    return setInputProperties({});
  }, [InputProps, currency]);

  return (
    <TextField
      // datatype="number"
      value={!value && value !== 0 ? "" : value}
      onChange={(e) => {
        if (!setValue) return undefined;
        let val = e.target.value.replaceAll(",", "");

        if (["-", "0.", ".", "-0"].indexOf(val) > -1) {
          return setValue(val as any);
        }

        if (!val) {
          return setValue(0);
        }

        if (val.startsWith("0") && val.length > 1) {
          val = val.slice(1, val.length);
        }

        if (Number.isNaN(parseFloat(val.replace(".", "")))) {
          return undefined;
        }
        if (val.endsWith(".")) {
          return setValue(val as any);
        }
        if (val.endsWith(".0")) {
          return setValue(val as any);
        }
        if (val.endsWith("0")) {
          return setValue(val as any);
        }

        if (decimalPlaces === undefined) {
          const split = val.split(".");
          const a = split[0] + (split[1] ? `.${split[1].slice(0, 2)}` : "");

          return setValue(parseFloat(a));
        }
        const split = val.split(".");
        const a = split[0] + (split[1] ? `.${split[1].slice(0, 2)}` : "");
        return setValue(a as any);
      }}
      // type="number"
      fullWidth={fullWidth}
      disabled={disabled}
      style={style}
      inputProps={{
        style: {
          ...style,
          padding: 0,
        },
      }}
      sx={sx}
      size={size}
      placeholder={placeholder}
      variant={variant}
      // inputProps={{ type: "number" }}
      // inputProps={inputProps}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      // InputProps={InputProps}
      error={error}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      InputProps={InputProperties}
    />
  );
};

export default NumberTextfield;
